export const GUEST_TOKENS_KEY = 'vboardGuestTokens';
export const GUEST_LAST_NAME_KEY = 'vboardGuestLastName';
// pre-multi-guest storage: a single token, migrated into the map on first read
const LEGACY_GUEST_TOKEN_KEY = 'vboardGuestToken';

function normalizeName(name) {
    return (name || '').trim().toLowerCase();
}

// Decode without verification - only used to prefill the guest name and skip
// expired tokens client-side. The server re-verifies the signature.
export function parseJwtPayload(token) {
    if (!token) {
        return null;
    }
    try {
        let base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(window.atob(base64));
    } catch (err) {
        return null;
    }
}

function isValidPayload(payload) {
    return !!(payload && payload.purpose === 'guest' && payload.exp && payload.exp * 1000 > Date.now());
}

function loadTokens() {
    let tokens = {};
    try {
        tokens = JSON.parse(window.localStorage.getItem(GUEST_TOKENS_KEY)) || {};
    } catch (err) {
        tokens = {};
    }
    let legacy = window.localStorage.getItem(LEGACY_GUEST_TOKEN_KEY);
    if (legacy) {
        let payload = parseJwtPayload(legacy);
        if (isValidPayload(payload) && payload.name && !tokens[normalizeName(payload.name)]) {
            tokens[normalizeName(payload.name)] = legacy;
            if (!window.localStorage.getItem(GUEST_LAST_NAME_KEY)) {
                window.localStorage.setItem(GUEST_LAST_NAME_KEY, normalizeName(payload.name));
            }
            saveTokens(tokens);
        }
        window.localStorage.removeItem(LEGACY_GUEST_TOKEN_KEY);
    }
    return tokens;
}

function saveTokens(tokens) {
    window.localStorage.setItem(GUEST_TOKENS_KEY, JSON.stringify(tokens));
}

export function getGuestTokenForName(name) {
    let token = loadTokens()[normalizeName(name)];
    return isValidPayload(parseJwtPayload(token)) ? token : null;
}

export function setGuestToken(name, token) {
    let tokens = loadTokens();
    for (let key of Object.keys(tokens)) {
        if (!isValidPayload(parseJwtPayload(tokens[key]))) {
            delete tokens[key];
        }
    }
    tokens[normalizeName(name)] = token;
    saveTokens(tokens);
    window.localStorage.setItem(GUEST_LAST_NAME_KEY, normalizeName(name));
}

export function clearGuestTokens() {
    window.localStorage.removeItem(GUEST_TOKENS_KEY);
    window.localStorage.removeItem(GUEST_LAST_NAME_KEY);
    window.localStorage.removeItem(LEGACY_GUEST_TOKEN_KEY);
}

// Display names of every guest identity with a still-valid token, most
// recently used first.
export function getStoredGuestNames() {
    let tokens = loadTokens();
    let lastKey = window.localStorage.getItem(GUEST_LAST_NAME_KEY);
    let names = [];
    for (let key of Object.keys(tokens)) {
        let payload = parseJwtPayload(tokens[key]);
        if (isValidPayload(payload) && payload.name) {
            if (key === lastKey) {
                names.unshift(payload.name);
            } else {
                names.push(payload.name);
            }
        }
    }
    return names;
}

// Payload of the most recently used guest identity (any valid one as a
// fallback) - callers use this as "there is a returning guest on this browser".
export function getValidGuestPayload() {
    let tokens = loadTokens();
    let lastKey = window.localStorage.getItem(GUEST_LAST_NAME_KEY);
    let candidates = lastKey && tokens[lastKey] ? [tokens[lastKey]] : [];
    candidates = candidates.concat(Object.values(tokens));
    for (let token of candidates) {
        let payload = parseJwtPayload(token);
        if (isValidPayload(payload)) {
            return payload;
        }
    }
    return null;
}
